import { render, staticRenderFns } from "./CustomerId.vue?vue&type=template&id=0ef5abae&scoped=true"
import script from "./CustomerId.vue?vue&type=script&lang=js"
export * from "./CustomerId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef5abae",
  null
  
)

export default component.exports